"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const emptyHash = 'e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855';
const sha256 = async (data) => {
    // this exists because of internet explorer (proprietary software)
    // in IE mscrypto does not handle empty inputs, but that's not standard
    // so we have to write dirty hacks like these
    if (typeof data === 'string' && !data.length)
        return emptyHash;
    const msgArr = typeof data === 'string' ? new TextEncoder().encode(data) : data;
    const buffer = await crypto.subtle.digest('SHA-256', msgArr);
    const hashArray = Array.from(new Uint8Array(buffer));
    return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
};
const type = (m) => (Object.prototype.toString.call(m).match(/^\[object (\w+)\]/) || [])[1].toLowerCase();
const getISODateTime = () => new Date()
    .toISOString()
    .replace(/[-:]/g, '')
    .replace(/\.[0-9]{3}/, '');
exports.default = ({ authURL, retryCount = 2, retryDelay = 250 }) => async (resource, init) => {
    const options = type(resource) === 'object' ? resource : init;
    const url = typeof resource === 'string' ? resource : options.url;
    const { host, pathname, search } = new URL(url);
    const qs = search.slice(1);
    const datetime = getISODateTime();
    const bodyIsStream = window.ReadableStream && options.body instanceof ReadableStream;
    if (bodyIsStream)
        throw new Error('AWSSignedFetch: fetch body of ReadableStream is not supported');
    const contentSHA = options.unsignedPayload
        ? 'UNSIGNED-PAYLOAD'
        : await sha256(options.body || '');
    let _headers = {
        host,
        'x-amz-date': datetime,
        ...options.headers,
    };
    const formattedHeaders = Object
        .entries(_headers)
        .map(([key, value]) => [
        key.toLowerCase().trim(),
        value.trim(),
    ])
        .sort((a, b) => a[0].localeCompare(b[0]));
    const headersText = formattedHeaders
        .map(([key, value]) => `${key}:${value}`)
        .join('\n');
    const headerKeys = formattedHeaders
        .map(([key]) => key)
        .join(';');
    const canonicalRequest = [
        options.method,
        pathname,
        qs,
        headersText,
        '',
        headerKeys,
        contentSHA,
    ].join('\n');
    const hashedCanonicaRequest = await sha256(canonicalRequest);
    const authRequest = `${authURL}?request=${hashedCanonicaRequest}&datetime=${datetime}`;
    const auth = await fetch(authRequest);
    const { credential, signature } = await auth.json();
    const doTheRequest = () => fetch(url, {
        ...options,
        headers: {
            ..._headers,
            Authorization: `AWS4-HMAC-SHA256 Credential=${credential}, SignedHeaders=${headerKeys}, Signature=${signature}`,
            'x-amz-content-sha256': contentSHA,
        },
    }).then((res) => {
        // ok means 200-299 status codes. this could be too restrictive. wait for complaints and adjust if needed
        if (!res.ok)
            throw new Error(`http fail: ${res.url} - ${res.status}`);
        return res;
    });
    let tryCount = 0;
    const run = async () => {
        tryCount += 1;
        if (tryCount > retryCount) {
            throw new Error(`AWSSignedFetch: tried to fetch() ${tryCount} times but was not successful`);
        }
        try {
            return doTheRequest();
        }
        catch (e) {
            console.error(e);
            await new Promise(done => setTimeout(done, retryDelay));
            return run();
        }
    };
    return run();
};
//# sourceMappingURL=main.js.map